import { useQuery } from "@apollo/client";
import gql from "graphql-tag";
import { useMemo } from "react";
import { useRealmApp } from "../RealmApp";
import { mapToEntity } from "../helpers/dataHelper";
import { useDatesContext } from "context/DatesContext";

const useSubcategories = () => {
  const app = useRealmApp();
  const { subcategories, loading } = useAllSubcategories(app.currentUser.id);
  const subcategoryMap = useMemo(
    () => mapToEntity(subcategories),
    [subcategories]
  );
  return {
    loading,
    subcategories,
    subcategoryMap,
  };
};

export default useSubcategories;

function useAllSubcategories(ownerId) {
  const { getCacheControl } = useDatesContext();
  const fetchPolicy = getCacheControl("useAllSubcategories", 60 * 1000);
  //
  const { data, loading, error } = useQuery(
    gql`
      query getSubcategories($ownerId: String!) {
        subcategories(query: { owner_id: $ownerId }, limit: 0) {
          _id
          name
          color
          image
          categoryId
          updateDatetime
          creationDatetime
        }
      }
    `,
    { variables: { ownerId }, fetchPolicy }
  );
  if (error) {
    throw new Error(`Failed to fetch tasks: ${error.message}`);
  }
  // If the query has finished, return the tasks from the result data
  // Otherwise, return an empty list
  const subcategories = data?.subcategories ?? [];
  return { subcategories, loading };
}

export const useCategories = () => {
  const app = useRealmApp();
  const { categories, loading } = useAllCategories(app.currentUser.id);
  const categoryMap = useMemo(() => mapToEntity(categories), [categories]);
  return {
    loading,
    categories,
    categoryMap,
  };
};

function useAllCategories(ownerId) {
  const { getCacheControl } = useDatesContext();
  const fetchPolicy = getCacheControl("useAllCategories", 60 * 1000);
  //
  const { data, loading, error } = useQuery(
    gql`
      query getCategories($ownerId: String!) {
        categories(query: { owner_id: $ownerId }, limit: 0) {
          _id
          name
          color
          image
          updateDatetime
          creationDatetime
        }
      }
    `,
    { variables: { ownerId }, fetchPolicy }
  );
  if (error) {
    throw new Error(`Failed to fetch tasks: ${error.message}`);
  }
  // If the query has finished, return the tasks from the result data
  // Otherwise, return an empty list
  const categories = data?.categories ?? [];
  return { categories, loading };
}
